module.exports = __webpack_public_path__ + "static/media/trimble_white.50686b88.png";